import http from '../versa/http.js';

// Script set-api-host.ps1 atualiza API_BASE; '' = same-origin quando servido pela API
const API_BASE = 'https://sessp.sialwms.com.br';
const HOST = (typeof window !== 'undefined' && window.location.port === '8001') ? '' : API_BASE;
//const HOST = 'https://api.mdutra.com:1604';	// Dev docker-compose

const API = {

	call: http,

	// AUTH

	async auth(username, password)
	{
		let endpoint = `${HOST}/auth`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: `username=${username}&password=${password}`
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async request_password(data)
	{
		let endpoint = `${HOST}/auth/requests`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async reset_password(data)
	{
		let endpoint = `${HOST}/auth/resets`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// ENDPOINTS

	async list_endpoints(query = '')
	{
		let endpoint = `${HOST}/endpoints${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_endpoint(data)
	{
		let endpoint = `${HOST}/endpoints`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_endpoint(endpoint_id, data)
	{
		let endpoint = `${HOST}/endpoints/${endpoint_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_endpoint(endpoint_id)
	{
		let endpoint = `${HOST}/endpoints/${endpoint_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_endpoint(endpoint_id)
	{
		let endpoint = `${HOST}/endpoints/${endpoint_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// GROUPS

	async list_groups(query = '')
	{
		let endpoint = `${HOST}/groups${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_group(data)
	{
		let endpoint = `${HOST}/groups`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_group(group_id, data)
	{
		let endpoint = `${HOST}/groups/${group_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_group(group_id)
	{
		let endpoint = `${HOST}/groups/${group_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_group(group_id)
	{
		let endpoint = `${HOST}/groups/${group_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// USERS

	async list_users(query = '')
	{
		let endpoint = `${HOST}/users${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_user(data)
	{
		let endpoint = `${HOST}/users`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_user(user_id, data)
	{
		let endpoint = `${HOST}/users/${user_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_user(user_id)
	{
		let endpoint = `${HOST}/users/${user_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_user(user_id)
	{
		let endpoint = `${HOST}/users/${user_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// LOGS

	async list_logs(query = '')
	{
		let endpoint = `${HOST}/logs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_log(log_id)
	{
		let endpoint = `${HOST}/logs/${log_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_integration_events(query = '')
	{
		let endpoint = `${HOST}/integration-events${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_integration_event(integration_event_id)
	{
		let endpoint = `${HOST}/integration-events/${integration_event_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_integration_event(data)
	{
		let endpoint = `${HOST}/integration-events`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async integration_events_summary(hours = 24, stale_minutes = 12)
	{
		let endpoint = `${HOST}/integration-events/summary?hours=${encodeURIComponent(hours)}&stale_minutes=${encodeURIComponent(stale_minutes)}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// VERSION
	
	async version()
	{
		let endpoint = `${HOST}/version`;
		let response = await fetch(endpoint);
		return response;
	},

}

export default API;

